import type { JSX } from 'react'

export const AngleRightIcon = (): JSX.Element => (
  <use href='#angleRightIcon' height='100%' width='100%' />
)
